import React from "react";
import { Chip, Tooltip } from "@mui/material";
import WorkspacesOutlinedIcon from "@mui/icons-material/WorkspacesOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";

/**
 * Chip de marcação do Grupo Econômico.
 * - Sem `label`: chip "Grupo" (marca um cliente virtual de grupo econômico).
 * - Com `variant="owner"` e `label`: chip com o nome do cliente membro dono
 *   (usado para rotular contratos/faturas/serviços em visões consolidadas).
 */
export default function GrupoChip({ label, variant = "grupo", sx = {} }) {
	if (variant === "owner") {
		if (!label) return null;
		return (
			<Tooltip title={`Cliente: ${label}`}>
				<Chip
					size="small"
					icon={<PersonOutlineOutlinedIcon />}
					label={label}
					variant="outlined"
					color="default"
					sx={{ maxWidth: 220, ...sx }}
				/>
			</Tooltip>
		);
	}

	return (
		<Chip
			size="small"
			icon={<WorkspacesOutlinedIcon />}
			label={label || "Grupo"}
			color="default"
			variant="outlined"
			sx={{ height: 20, ...sx }}
		/>
	);
}
